import { Injectable, signal } from '@angular/core';

/** Coordinates the project navigation drawer with the responsive app header. */
@Injectable({ providedIn: 'root' })
export class ProjectNavigationService {
  private readonly _open = signal(false);

  readonly open = this._open.asReadonly();

  show(): void {
    this._open.set(true);
  }

  hide(): void {
    this._open.set(false);
  }

  toggle(): void {
    this._open.update((open) => !open);
  }

  setOpen(open: boolean): void {
    this._open.set(open);
  }
}
